import { useLocation, useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  postActivateAccount,
  postActivateAccountOtp,
  postResendClientCredentialsEmail,
  resendOtpCode,
  verifyForgetOtp,
  verifyForgetUsernameOtp,
  verifyLoginOtp,
  verifyOnlineAccessOtp,
  verifyUserOtp,
} from '../../store/actions/authActions';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useSearchParams } from 'react-router-dom';
import { setClientCredentialsGenerateOtp, verifyCredentialOtp } from '../../store/actions/corporateAction';
import { setAuthLoading } from '../../store/slices/authSlice';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { authContent } = useSelector((state) => state.content);
  const { authLoading } = useSelector((state) => state.auth);

  const [seconds, setSeconds] = useState(120);
  const [token, setToken] = useState(null);
  const [newClientId, setNewClientId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const data = location?.state;

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_forget_screen?.data?.attributes, key, isArabic);
  };

  const getToken = () => {
    const token = searchParams.get('token');
    setToken(token ?? null);
    if (token) {
      dispatch(
        setClientCredentialsGenerateOtp(token, (res) => {
          setNewClientId(res?.result?.clientId);
        }),
      );
    }
  };

  const onPressResetPassword = (values) => {
    try {
      dispatch(setAuthLoading(true))

      const apiData = {
        otpCode: values?.otp,
        userName: data?.userName,
        clientCode: data?.clientCode,
        clientId: data?.clientId,
      };

      const otpData = {
        otpCode: values?.otp,
        clientId: data?.clientId,
      };

      if (token) {
        otpData.clientId = newClientId;
        dispatch(
          verifyCredentialOtp(otpData, (res) => {
            navigate('/set-client-credentials', {
              replace: true,
              state: { clientId: res?.result?.clientId }
            });
          }),
        );
      } else if (data?.isForgetPassword) {
        dispatch(verifyForgetOtp(apiData, () => navigate('/reset-password', {
          replace: true,
          state: { ...apiData }
        })));
      } else if (data?.data?.is_activate_account) {
        const otpData = {
          otpCode: values?.otp,
          mobileNumber: data?.data?.api_data?.mobileNumber,
          languageId: data?.data?.api_data?.languageId,
        };
        dispatch(postActivateAccountOtp(otpData, (res) => {
          dispatch(postResendClientCredentialsEmail(otpData, () => {
            navigate('/')
          }))
        }));
      } else if (data?.isLogin) {
        dispatch(verifyLoginOtp(otpData, navigate));
      } else {
        dispatch(verifyUserOtp(otpData, navigate));
      }
    } catch (error) {
      dispatch(setAuthLoading(false))
    }

  };

  const handleResend = () => {
    const apiData = {
      clientId: data?.clientId ?? data?.clientCode,
      InvestorTypeId: 1,
    };
    if (data?.data?.is_activate_account) {
      const api_data = {
        mobileNumber: data?.data?.api_data?.mobileNumber,
        languageId: data?.data?.api_data?.languageId,
      };
      dispatch(postActivateAccount(api_data, () => setSeconds(120)));
    } else {
      dispatch(resendOtpCode(apiData, () => setSeconds(120)));
    }
  };

  const formatTime = () => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${minutes?.toString()?.padStart(2, 0)}:${secs?.toString()?.padStart(2, 0)}`;
  };

  return {
    TextWeight,
    isArabic,
    onPressResetPassword,
    navigate,
    getContentKey,
    authLoading,
    handleResend,
    formatTime,
    seconds,
  };
};
